module.exports = __webpack_public_path__ + "static/media/saveforyourfuture.988d4635.svg";